import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { logAnalyticsEvent } from '../../../redux/actions/analyticsLog';
import { getOnboardingActions } from '../../../redux/actions/getOnboardingActions';
import { makeIsReloadAboutWholeHome } from '../../../redux/selectors/homepageSelector';
import { makeIsNewCustomer } from '../../../redux/selectors/member';
import {
  makeDataByKey,
  makeIsFetchingWholeOnboarding,
  makeIsNewFetching,
  makeProductIdsSelector,
} from '../../../redux/selectors/onboarding';
import OnboardingList from './OnboardingList';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    isFetchingWholeOnboarding: makeIsFetchingWholeOnboarding(),
    loadingType: makeDataByKey('listLoadingType'),
    isNewCustomer: makeIsNewCustomer(),
    onBoardingIdList: makeProductIdsSelector({ count: 10 }),
    isNewFetching: makeIsNewFetching(),
    isHomePageReload: makeIsReloadAboutWholeHome(),
  });

  return state => selector(state);
};

const mapDispatchToProps = {
  logEvent: logAnalyticsEvent,
  getOnboardingList: getOnboardingActions.request,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(OnboardingList);
